import { Component, Input } from "@angular/core"
import { BsModalService, ModalOptions } from "ngx-bootstrap/modal"
import { ScoutTask } from "../../../core/models"
import { ScoutTaskDoc } from "../../../core/schema/scout-task-schema"

export type Scout3dModalInitialState = {
  scoutTaskDoc: ScoutTask
  pathIds?: string[]
}

@Component({
    selector: 'modal-content',
    templateUrl: './scout-kml-viewer-modal.component.html',
    styleUrls: ['../../../shared/mapping/kml/kml-viewer/kml-viewer-modal.component.scss']
  })
  export class ScoutKmlViewerModal {

    static readonly ModalId = 20220302

    static show( bsModalService: BsModalService, initialState: Scout3dModalInitialState ) {
      const context : ModalOptions = {
        initialState,
        class: 'kml-viewer-modal',
        id: ScoutKmlViewerModal.ModalId,
        animated: true,
        ignoreBackdropClick: true    
      }
      return bsModalService.show(ScoutKmlViewerModal, context );
    }

    @Input() scoutTaskDoc : ScoutTaskDoc
    @Input() pathIds: string[] = []


    constructor( private modalService: BsModalService) {
    }

    onCloseModal = () => {
      this.modalService.hide(ScoutKmlViewerModal.ModalId)
    }
 
}